"use strict";
// --------------------------------------------------
// BOOLEAN HELPER
// Convert a boolean value into a string
// --------------------------------------------------
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bool = void 0;
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
/**
 * @param {boolean|any} data
 * @param {string} true_value
 * @param {string} false_value
 * @param {string} default_value
 */
function bool(data, true_value, false_value, default_value) {
    if ((0, isPlainObject_1.default)(true_value)) {
        true_value = '';
    }
    switch (data) {
        case true:
            return true_value || 'Yes';
        case false:
            return false_value || 'No';
        default:
            return default_value || 'Unknown';
    }
}
exports.bool = bool;
